module.exports = __webpack_public_path__ + "img/ico_device_pc_on.890101ff.svg";